import { Container, Grid, Section } from '@radix-ui/themes';
import CompositeGraph from '@/components/CompositeGraph';
import DetailCallout from '@/components/Detail/DetailCallout';
import { Sheet } from '@/components/Sheet/Sheet';
import { useSeedIds } from '@/database/repositories/exampleRepository';

export default function HomePage() {
  const metrics = useSeedIds() ?? [];

  return (
    <Container>
      <Section>
        <CompositeGraph />
      </Section>
      <Section>
        <Sheet />
      </Section>
      <Section>
        <Grid columns={{ initial: '1', sm: '2' }} gap="4" width="100%">
          {metrics.map((id) => {
            return <DetailCallout metricId={id} key={id} />;
          })}
        </Grid>
      </Section>
    </Container>
  );
}
